import React, { useState } from "react";
import { Grid, Typography } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import TestOption from "../compnents/TestOption";
import FileUploader from "@jumbo/Dashboards/Media/FileUploader";
import TestTitle from "../compnents/TestTitle";
import ImagePicker from "../compnents/ImagePicker";

const useStyles = makeStyles((theme) => ({
  cardContainer: {
    marginTop: 10,
  },
  answerSelctText: {
    color: theme.palette.primary.main,
    fontWeight: "bold",
  },
}));

const RangeQuestionElment = ({
  questoinTitle,
  setQuestoinTitle,
  cover,
  setCover,
  score,
  setScore,
  minRange,
  setMinRange,
  maxRange,
  setMaxRange,
  minRangeAnswer,
  setMinRangeAnswer,
  maxRangeAnswer,
  setMaxRangeAnswer,
  stepSizeRange,
  setStepSizeRange,
}) => {
  const classes = useStyles();
  const [openFileUploader, setOpenFileUploader] = useState(false);

  return (
    <React.Fragment>
      <TestTitle
        value={questoinTitle}
        handeChange={(value) => setQuestoinTitle(value)}
      />
      <Grid item xs={12}>
        <Typography className={classes.answerSelctText}>
          انتخاب تصویر سوال
        </Typography>
        <ImagePicker
          cover={cover}
          handlePick={() => setOpenFileUploader(true)}
          handleRevome={() => setCover("")}
          previewStyles={{ marginInline: "auto", marginBlock: "20px" }}
          placeHolderStyles={{ marginInline: "auto", marginBlock: "20px" }}
        />
      </Grid>
      <TestOption
        text={""}
        title={"حداقل"}
        type={"number"}
        value={minRange}
        handleChange={(value) => setMinRange(+value)}
      />
      <TestOption
        text={""}
        title={"حداکثر"}
        type={"number"}
        value={maxRange}
        handleChange={(value) => setMaxRange(+value)}
      />
      <TestOption
        text={""}
        title={"حداقل پاسخ"}
        type={"number"}
        value={minRangeAnswer}
        handleChange={(value) => setMinRangeAnswer(+value)}
      />
      <TestOption
        text={""}
        title={"حداکثر پاسخ"}
        type={"number"}
        value={maxRangeAnswer}
        handleChange={(value) => setMaxRangeAnswer(+value)}
      />
      <TestOption
        text={""}
        title={"فاصله بین اعداد"}
        type={"number"}
        value={stepSizeRange}
        handleChange={(value) => setStepSizeRange(+value)}
      />
      <TestOption
        text={""}
        title={"پله"}
        type={"number"}
        value={score}
        handleChange={(value) => setScore(+value)}
      />
      <FileUploader
        selectMode
        open={openFileUploader}
        handleClose={() => setOpenFileUploader(false)}
        handleSelect={(selected) => setCover(selected)}
        selectedItem={cover}
        imageSelector={true}
      />
    </React.Fragment>
  );
};

export default RangeQuestionElment;
